import { defineMessages } from 'react-intl';

export const messages: {
	positionExternalKey: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	positionTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	positionExternalKey: {
		id: 'search_talent_position.external_position_key',
		defaultMessage: 'External key {positionExternalKey}',
		description:
			"The text is shown as a metadata label on a talent position search result card displaying the external key of the position. The placeholder {positionExternalKey} will be substituted with the position's external identifier string.",
	},
	positionTitle: {
		id: 'search_talent_position.position_title',
		defaultMessage:
			'{preferredName, select, undefined {{positionKey}} other {{positionKey}: {preferredName}}}',
		description:
			'The text is shown as the title of a talent position search result card. The placeholder {positionKey} will be substituted with the position key, and {preferredName} with the preferred display name when available.',
	},
});
